// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.userdata-container {
  padding: 30px;
}

/* Search box */
.userdata-search {
  padding: 8px;
  font-size: 14px;
  width: 300px;
  margin-bottom: 16px;
}

/* Files table */
.userdata-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  overflow: hidden;
}

.userdata-table thead {
  background: #273d3b;
}

.userdata-table th {
  color: #fff;
  text-align: left;
  padding: 10px 12px;
  font-weight: 600;
}

.userdata-table td {
  padding: 2px 2px;
  border-bottom: 1px solid #e5e7eb;
}

.userdata-table tbody tr:hover {
  background: #f5f7f7;
}

.userdata-table tbody tr.selected {
  background: #e6f0ef;
}

.userdata-th-select,
.userdata-td-select {
  width: 40px;
  text-align: center;
}

.userdata-th-sort {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.userdata-th-sort:hover {
  background: #31514e;
}

.userdata-sort-icon {
  opacity: 0.5;
  margin-left: 4px;
  vertical-align: middle;
}

.userdata-sort-icon.active {
  opacity: 1;
}

.userdata-empty {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 20px;
}

/* Pagination */
.userdata-pagination {
  margin-top: 10px;
  text-align: center;
}

.userdata-page-btn {
  margin: 0 4px;
  padding: 4px 8px;
  background: #eee;
  color: #000;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.userdata-page-btn.active {
  background: #007bff;
  color: #fff;
}

/* Action buttons */
.userdata-actions {
  margin-top: 20px;
}

.userdata-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
  color: #fff;
}

.userdata-btn.delete {
  background-color: #dc3545;
}

.userdata-btn.download {
  background-color: #007bff;
}

.userdata-btn.upload {
  background-color: #28a745;
  margin-left: 20px;
}

.userdata-btn.cancel-upload {
  background-color: #6c757d;
}

.userdata-btn.start-upload {
  background-color: #007bff;
  margin-top: 20px;
}

/* Upload section */
.userdata-upload-section {
  margin-top: 30px;
}

.userdata-project-input {
  padding: 8px;
  font-size: 14px;
  width: 300px;
  margin-bottom: 16px;
}

/* Dropzone */
.userdata-dropzone {
  border: 2px dashed #aaa;
  padding: 20px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 20px;
}

/* Upload grid */
.userdata-upload-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

/* Upload card */
.userdata-upload-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  width: 240px;
  background-color: #f9f9f9;
}

/* Progress bar */
.userdata-progress-bar {
  height: 8px;
  background-color: #eee;
  border-radius: 4px;
  margin-top: 8px;
  margin-bottom: 8px;
  overflow: hidden;
}

.userdata-progress-fill {
  height: 100%;
  background-color: #007bff;
  transition: width 0.3s ease;
}

.userdata-progress-fill.error {
  background-color: #dc3545;
}

/* Progress text */
.userdata-progress-text {
  font-size: 12px;
  color: #333;
}

.userdata-progress-text.error {
  color: #dc3545;
}

/* Remove file link */
.userdata-remove-file {
  margin-top: 8px;
  font-size: 12px;
  color: #007bff;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
}

.userdata-btn.sra-download {
  background-color: #8a2be2; /* purple accent */
  color: #fff;
  margin-left: 10px;
}

/* Project selection section */
.userdata-project-section {
  margin-bottom: 20px;
}

.userdata-divider {
  text-align: center;
  margin: 10px 0;
  font-weight: bold;
}

.userdata-project-select {
  width: 300px;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
  margin-bottom: 16px;
}

/* Row container */
.userdata-project-row {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  margin-bottom: 20px;
}

/* Each column */
.userdata-project-col {
  display: flex;
  flex-direction: column;
}

/* OR divider */
.userdata-project-or {
  font-weight: bold;
  margin-bottom: 8px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/css/UserData.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;AACf;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,WAAW;EACX,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["/* Container */\n.userdata-container {\n  padding: 30px;\n}\n\n/* Search box */\n.userdata-search {\n  padding: 8px;\n  font-size: 14px;\n  width: 300px;\n  margin-bottom: 16px;\n}\n\n/* Files table */\n.userdata-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.userdata-table thead {\n  background: #273d3b;\n}\n\n.userdata-table th {\n  color: #fff;\n  text-align: left;\n  padding: 10px 12px;\n  font-weight: 600;\n}\n\n.userdata-table td {\n  padding: 2px 2px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.userdata-table tbody tr:hover {\n  background: #f5f7f7;\n}\n\n.userdata-table tbody tr.selected {\n  background: #e6f0ef;\n}\n\n.userdata-th-select,\n.userdata-td-select {\n  width: 40px;\n  text-align: center;\n}\n\n.userdata-th-sort {\n  cursor: pointer;\n  user-select: none;\n  white-space: nowrap;\n}\n\n.userdata-th-sort:hover {\n  background: #31514e;\n}\n\n.userdata-sort-icon {\n  opacity: 0.5;\n  margin-left: 4px;\n  vertical-align: middle;\n}\n\n.userdata-sort-icon.active {\n  opacity: 1;\n}\n\n.userdata-empty {\n  text-align: center;\n  color: #6b7280;\n  font-style: italic;\n  padding: 20px;\n}\n\n/* Pagination */\n.userdata-pagination {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.userdata-page-btn {\n  margin: 0 4px;\n  padding: 4px 8px;\n  background: #eee;\n  color: #000;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.userdata-page-btn.active {\n  background: #007bff;\n  color: #fff;\n}\n\n/* Action buttons */\n.userdata-actions {\n  margin-top: 20px;\n}\n\n.userdata-btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n  color: #fff;\n}\n\n.userdata-btn.delete {\n  background-color: #dc3545;\n}\n\n.userdata-btn.download {\n  background-color: #007bff;\n}\n\n.userdata-btn.upload {\n  background-color: #28a745;\n  margin-left: 20px;\n}\n\n.userdata-btn.cancel-upload {\n  background-color: #6c757d;\n}\n\n.userdata-btn.start-upload {\n  background-color: #007bff;\n  margin-top: 20px;\n}\n\n/* Upload section */\n.userdata-upload-section {\n  margin-top: 30px;\n}\n\n.userdata-project-input {\n  padding: 8px;\n  font-size: 14px;\n  width: 300px;\n  margin-bottom: 16px;\n}\n\n/* Dropzone */\n.userdata-dropzone {\n  border: 2px dashed #aaa;\n  padding: 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n/* Upload grid */\n.userdata-upload-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n/* Upload card */\n.userdata-upload-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 12px;\n  width: 240px;\n  background-color: #f9f9f9;\n}\n\n/* Progress bar */\n.userdata-progress-bar {\n  height: 8px;\n  background-color: #eee;\n  border-radius: 4px;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  overflow: hidden;\n}\n\n.userdata-progress-fill {\n  height: 100%;\n  background-color: #007bff;\n  transition: width 0.3s ease;\n}\n\n.userdata-progress-fill.error {\n  background-color: #dc3545;\n}\n\n/* Progress text */\n.userdata-progress-text {\n  font-size: 12px;\n  color: #333;\n}\n\n.userdata-progress-text.error {\n  color: #dc3545;\n}\n\n/* Remove file link */\n.userdata-remove-file {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #007bff;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.userdata-btn.sra-download {\n  background-color: #8a2be2; /* purple accent */\n  color: #fff;\n  margin-left: 10px;\n}\n\n/* Project selection section */\n.userdata-project-section {\n  margin-bottom: 20px;\n}\n\n.userdata-divider {\n  text-align: center;\n  margin: 10px 0;\n  font-weight: bold;\n}\n\n.userdata-project-select {\n  width: 300px;\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  margin-bottom: 16px;\n}\n\n/* Row container */\n.userdata-project-row {\n  display: flex;\n  align-items: flex-end;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n/* Each column */\n.userdata-project-col {\n  display: flex;\n  flex-direction: column;\n}\n\n/* OR divider */\n.userdata-project-or {\n  font-weight: bold;\n  margin-bottom: 8px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
